require('./ProgramOthers.scss');

const b = require('app/www/libs/b')('program-others');

const _ = {
    get: require('lodash/get'),
};

const Metrika = require('app/www/libs/client/metrika');

const React = require('react');
const PropTypes = require('prop-types');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const Icon = require('app/www/components/blocks/Icon/Icon');
const Link = require('app/www/components/blocks/Link/Link');
const ProgramRating = require('app/www/components/blocks/ProgramRating/ProgramRating');
const ProgramSubtitle = require('app/www/components/blocks/ProgramSubtitle/ProgramSubtitle');
const Scroll = require('app/www/components/blocks/Scroll/Scroll');
const Spin = require('app/www/components/blocks/Spin/Spin');

const EVENTS_COUNT = 3;

class ProgramOthers extends React.PureComponent {

    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
    }

    render() {
        const {
            i18n,
            events,
            titleKey,
            isLoading,
            isLayoutColumnsSmall,
        } = this.props;

        const programSubtitleProps = {
            text: i18n.get(`program-others.title-${titleKey}`),
        };

        const spinProps = {
            mods: {
                size: 'm',
            },
        };

        const scrollProps = {
            touch: true,
        };

        const slicedEvents = isLayoutColumnsSmall ? events : events.slice(0, EVENTS_COUNT);

        return (
            <div className={b()}>
                <div className={b('title')}>
                    <ProgramSubtitle {...programSubtitleProps} />
                </div>
                {isLoading && (
                    <div className={b('loading')}>
                        <Spin {...spinProps} />
                    </div>
                )}
                {!isLoading && (
                    <Scroll {...scrollProps}>
                        {slicedEvents.map(event => this._renderEvent(event))}
                    </Scroll>
                )}
            </div>
        );
    }

    /**
     * @param {Object} event
     * @returns {Object}
     * @private
     */
    _renderEvent(event) {
        const {
            req,
            i18n,
            availableChannels,
        } = this.props;

        const {
            id,
            url,
            live,
            title,
            start,
            program,
            channelId,
        } = event;

        const image = program.images[0];
        const genre = program.type.name;

        const linkProps = {url};

        const imageStyle = {
            backgroundImage: `url('${_.get(image, 'sizes.200.src', '')}')`,
        };

        const iconLiveProps = {
            mods: {
                live: true,
                size: 's',
            },
        };

        const programRatingProps = program.rating && {
            mods: {
                size: 'm',
            },
            rate: program.rating.rate,
        };

        const moment = req.lib('moment');
        const date = moment.getFormattedDate('dd, DD MMMM', start, i18n);
        const time = i18n.get('program-others.time', {time: moment.getFormattedDate('HH:mm', start)});
        const channel = availableChannels.filter(availableChannel => availableChannel.id === channelId)[0];

        return (
            <Link
                key={id}
                className={b('event')}
                {...linkProps}
                onClick={this._onClick(genre)}
            >
                <span className={b('image')}>
                    <span className={b('image')} style={imageStyle} />
                    {program.rating && (
                        <span className={b('rating')}>
                            <ProgramRating {...programRatingProps} />
                        </span>
                    )}
                </span>
                <span className={b('name')}>
                    {live && <Icon className={b('live')} {...iconLiveProps} />}
                    {` ${title}`}
                </span>
                <span className={b('meta')}>
                    <span className={b('date')}>
                        {date} {time}
                    </span>
                    {channel && (
                        <span className={b('channel')}>
                            <i className={b('bull')}>•</i>
                            {channel.name}
                        </span>
                    )}
                </span>
            </Link>
        );
    }

    /**
     * @private
     */
    _onClick(genre) {
        return () => {
            Metrika.trackParams('TV_RECOMMENDED', {
                type: 'editorial',
                genre: genre || '',
            });
        };
    }

}

ProgramOthers.defaultProps = {
    isLoading: true,
};

ProgramOthers.propTypes = {
    titleKey: PropTypes.string,
    events: PropTypes.arrayOf(PropTypes.object).isRequired,
    availableChannels: PropTypes.arrayOf(PropTypes.object),
    isLoading: PropTypes.bool,
    isLayoutColumnsSmall: PropTypes.bool,
};

module.exports = withReq(withI18n(ProgramOthers));
